export const EASE = [0.16, 1, 0.3, 1];

/** Natural size/position morphs (layout animations). */
export const SPRING_LAYOUT = { type: "spring", stiffness: 210, damping: 28, mass: 0.8 };

/**
 * Staggered "scene" choreography for stage bodies.
 * Transform + opacity only — no filters — so changes read as UI state, not effects.
 */
export const sceneContainer = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.2, staggerChildren: 0.055, delayChildren: 0.06 } },
  exit: { opacity: 0, y: -4, transition: { duration: 0.18, ease: [0.4, 0, 1, 1] } },
};
export const sceneItem = {
  hidden: { opacity: 0, y: 6 },
  show: { opacity: 1, y: 0, transition: { duration: 0.38, ease: EASE } },
};

export const fadeUp = {
  hidden: { opacity: 0, y: 8 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: EASE } },
};

export const stagger = {
  hidden: {},
  show: { transition: { staggerChildren: 0.06 } },
};

export const slideStep = {
  initial: { opacity: 0, x: 24 },
  animate: { opacity: 1, x: 0, transition: { duration: 0.32, ease: EASE } },
  exit: { opacity: 0, x: -24, transition: { duration: 0.2, ease: EASE } },
};

/** Cursor spotlight: writes the pointer position as CSS vars onto the hovered `[data-spot]` card.
    Pair with the `.spot` class (index.css). Attach to a parent's onMouseMove. */
export function trackSpot(e) {
  const tile = e.target.closest?.("[data-spot]");
  if (!tile) return;
  const r = tile.getBoundingClientRect();
  tile.style.setProperty("--mx", `${e.clientX - r.left}px`);
  tile.style.setProperty("--my", `${e.clientY - r.top}px`);
}
